import { render, staticRenderFns } from "./AccountInvestigationCard.vue?vue&type=template&id=42b8d42d&scoped=true&"
import script from "./AccountInvestigationCard.vue?vue&type=script&lang=js&"
export * from "./AccountInvestigationCard.vue?vue&type=script&lang=js&"
import style0 from "./AccountInvestigationCard.vue?vue&type=style&index=0&id=42b8d42d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8d42d",
  null
  
)

export default component.exports